import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { EventPlace, EventSponsors, EventContact } from '@/components/event';
import useEventContext from '@/contexts/event/useEventContext';
import { Box, IconButton } from '@mui/material';
import CollapseSection from '@/components/CollapseSection';
import Iconify from '@/components//Iconify';
import useMobile from '@/hooks/useMobile';
import CollapseBoxHtml from '@/templates/plus/components/CollapseBoxHtml';

export default function EventInfo({
  onClose = () => {},
  sx = {},
  hideCloseBtn = false,
}) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { event } = useEventContext();
  const { isMobile } = useMobile();
  const {
    event: { use_seats, about },
  } = event;
  const aboutRef = useRef(null);
  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'scroll',
        ...sx,
      }}
    >
      {use_seats && !isMobile && !hideCloseBtn && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Box
            sx={{
              'mt': 2,
              'width': '24px',
              'height': '24px',
              'display': 'flex',
              'alignItems': 'center',
              'justifyContent': 'center',
              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            <IconButton onClick={onClose}>
              <Iconify
                width={24}
                height={24}
                icon={'material-symbols:close'}
                sx={{
                  color: (theme) =>
                    theme.palette.mode === 'light'
                      ? theme.palette.grey[800]
                      : theme.palette.grey[200],
                }}
              />
            </IconButton>
          </Box>
        </Box>
      )}
      {show && (
        <>
          <CollapseBoxHtml html={about} minsize={60} />
          <CollapseSection title={t('checkout.global.place')} defaultExpanded>
            <EventPlace event={event} />
          </CollapseSection>
        </>
      )}

      {event.sponsors && (
        <CollapseSection title={t('checkout.global.sponsors')} defaultExpanded>
          <EventSponsors event={event} />
        </CollapseSection>
      )}

      <CollapseSection title={t('checkout.global.ContactOrganizer')} defaultExpanded>
        <EventContact event={event} />
      </CollapseSection>
    </Box>
  );
}
